export interface DocumentContract {
  uuid: string,
  title: string,
  category: string,
  file: string,
  preview_image: string
}